import React from "react";
import PageBanner from "./pageBanner/PageBanner";
import Content from "carbon-react/lib/components/content";

const CenteredContent = (props) => {
  return <Content align="center">{props.children}</Content>;
};

const LoggedOutBanner = () => {
  return (
    <PageBanner
      id="logged-out-banner"
      title="You have successfully logged out."
    >
      <CenteredContent>
        For your security, please close your browser.
      </CenteredContent>
    </PageBanner>
  );
};

export default LoggedOutBanner;
